<template>
    <div class="text-center space-y-4">
      <h3 class="text-xl font-semibold text-gray-800">
        {{ $t("totalForm.goodbye.title") }}
      </h3>
      <p class="text-sm text-gray-600">
        {{ $t("totalForm.goodbye.desc") }}
      </p>
      <p class="text-xs text-gray-400">
        <a href="/contact" class="underline hover:text-primary">
          {{ $t("totalForm.goodbye.cta") }}
        </a>
      </p>
    </div>
  </template>
  
  <script lang="ts" setup>
  // This is a presentation-only component
  </script>